import { Accordion, Box, Heading } from '@chakra-ui/react';
import { ItemAccordion } from './ReferralFaqContent/ItemAccordion';
import { textItemsAccordion } from './ReferralFaqContent/faqTexts';

export const ReferralFaq = ({ firstBuyCoupon }) => {
  const ItemsAccordion = textItemsAccordion(firstBuyCoupon);

  return (
    <Box mb={4}>
      <Heading mb={5} fontSize="2xl">
        Perguntas frequentes - FAQ
      </Heading>

      <Accordion allowToggle>
        {ItemsAccordion.map(accordion => (
          <ItemAccordion
            key={accordion.title}
            Title={accordion.title}
            Body={accordion.body}
          />
        ))}
      </Accordion>
    </Box>
  );
};
